var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ua-size-picker"},_vm._l((_vm.groups),function(group,gIdx){return _c('ul',{key:gIdx,class:{
      'ua-size-picker-row': true,
      'is-free-column': _vm.freeColumn
    }},_vm._l((group),function(item,idx){return _c('li',{key:(idx + "_" + (item.value)),class:{
        'ua-size-picker-item': true,
        'is-free-column': _vm.freeColumn
      },style:(_vm.styles),on:{"click":function($event){return _vm.handleClick(Object.assign({}, item, {$index: idx}))}}},[_c('div',{class:{
          missoneposition: true,
          'is-medium': true,
          'ua-size-picker-inner': true,
          'is-free-column': _vm.freeColumn,
          'is-has-border': !item.isActived,
          'is-actived': item.isActived,
          'is-disabled': item.disabled,
          'is-ignore-disabled': _vm.ignoreDisabled,
          'is-unignore-disabled': !_vm.ignoreDisabled
        }},[_vm._v("\n        "+_vm._s(item.label)+"\n      ")])])}),0)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }